import React, { useMemo } from "react";
import { Box } from "@mui/material";
import useGetCampaignSummaryReport from "./hooks/useGetCampaignSummaryReport";
import CustomerStrategy from "./CustomerStrategy";
import ProductRecommendationStrategy from "./ProductRecommendationStrategy";

export default function CampaignSummaryReport({ organizationId, campaignId }) {
  const { data: report, loading, notFound, error } = useGetCampaignSummaryReport({
    organizationId,
    campaignId,
  });

  const customerSelectionStrategySuggestions = useMemo(
    () => report?.customerSelectionStrategySuggestions ?? [],
    [report]
  );
  const productRecommendationStrategySuggestions = useMemo(
    () => report?.productRecommendationStrategySuggestions ?? [],
    [report]
  );

  const showNoSuggestionsIndicator =
    notFound ||
    (!loading &&
      !error &&
      report &&
      customerSelectionStrategySuggestions.length === 0 &&
      productRecommendationStrategySuggestions.length === 0);

  return (
    <Box mt={{ xs: "14px", sm: "20px" }}>
      <CustomerStrategy
          report={report}
          error={error}
          loading={loading}
          showNoSuggestionsIndicator={showNoSuggestionsIndicator}
          customerSelectionStrategySuggestions={customerSelectionStrategySuggestions}
      />
      <Box mt={{ xs: '30px', sm: '42px'}}>
        <ProductRecommendationStrategy
            report={report}
            error={error}
            loading={loading}
            showNoSuggestionsIndicator={showNoSuggestionsIndicator}
            productRecommendationStrategySuggestions={productRecommendationStrategySuggestions}
        />
      </Box>
    </Box>
  );
}
